/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { Dialog } from '@ba/ba-ui-carbon-toolkit';

import PropTypes from 'util/PropTypes';
class InfoDialog extends Component {

	render() {
		const { title, body, dialogProps } = this.props;
		return (
			<Dialog { ...dialogProps } onClose={ this.props.onClose } >
				<Dialog.Header> {title} </Dialog.Header>
				<Dialog.Body> {body} </Dialog.Body>
				<Dialog.Footer>
					<Dialog.Button primary label="OK" onClick={ this.props.onClickOk }/>
					{ this.props.showCancelButton ? <Dialog.Button label="Cancel" onClick={ this.props.onClickCancel }/> : null }
				</Dialog.Footer>
			</Dialog>
		);
	}
}
InfoDialog.defaultProps = {
	title: '',
	body: '',
	showCancelButton: false,
	dialogProps: {
		'size': 'small',
		'clickaway': true,
		'width':'200px',
		'minWidth': '100px',
		'maxWidth': '400px'
	}//TODO: for consistence in explore, we maybe expose less props
};
InfoDialog.propTypes = {
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
	showCancelButton: PropTypes.boolean,
	onClose: PropTypes.func,
	onClickOk: PropTypes.func,
	onClickCancel: PropTypes.func,
	dialogProps: PropTypes.object
};

export default InfoDialog;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/InfoDialog.js